import React, { Component } from "react";
import {
  Input,
  Button,
  GridContainer,
  GridRow,
  GridColumn,
  Toastr,
  Utils,
  Modal,
  Select,
} from "arv-reactcomponents";
import PropTypes from "prop-types";
import { Login } from "arv-extends";
import { observer, inject } from "mobx-react";
import { WARRANTY_EXTENSION_COMPONENT } from "npmlinks-constants";
import Banner from "../Banner";
import WarrantyExtensionOtp from "../WarrantyExtensionOtp";
import RequiredField from "../../RequiredField";
import DateComponent from "../../DateComponent";

const { EmailInput, MobileNumberInput } = Login;

@inject("CommonStore")
@observer
class WarrantyForm extends Component {
  static getList(item) {
    return (
      <li className="nw-common-selectlist" key={item}>
        {item}
      </li>
    );
  }
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      nameErrorMsg: "",
      nameErrorClass: "",
      mobileNo: "",
      date: null,
      showOtpBlock: false,
      inpList: ["Gear", "Luggage"],
      productCategorySelectedValue: "Choose a Product Category",
      productCodeInputErrorMsg: "",
      productCodeErrorClass: "",
      purchaseList: ["Brand Store", "Dealership", "Online", "Gift"],
      purchaseSelectedValue: "Choose a Point of Purchase",
      dateOfPurchase: null,
      nameValidationRegex: [
        {
          pattern: /(.*[a-z]){3}/,
          msg: "Enter atleast 3 character.",
        },
      ],
      PRODUCT_CODE_REGEX: [
        {
          pattern: /^\d{13}$/,
          msg: "Enter 13 digits valid product code.",
        },
      ],
    };
    this.validateNameFieldRef = null;
    this.emailFields = null;
    this.mobileNoFieldsRef = null;
    this.sendForm = this.sendForm.bind(this);
    this.validateMobileNumber = this.validateMobileNumber.bind(this);
    this.getDateOfPurchase = this.getDateOfPurchase.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.otpVerified = this.otpVerified.bind(this);
    this.validateProductCode = this.validateProductCode.bind(this);
    this.getProductCategorySelection = this.getProductCategorySelection.bind(
      this,
    );
    this.getPurchaseSelectSelection = this.getPurchaseSelectSelection.bind(
      this,
    );
    this.getValidatedName = this.getValidatedName.bind(this);
    this.onNameFieldBlur = this.onNameFieldBlur.bind(this);
  }

  get finalFormData() {
    const {
      name,
      mobileNo,
      productCode,
      productCategorySelectedValue,
      purchaseSelectedValue,
      dateOfPurchase,
    } = this.state;
    const { email } = this.emailFields.state;

    return {
      name,
      email,
      mobileNo,
      productCategory: productCategorySelectedValue,
      productCode,
      pointOfPurchase: purchaseSelectedValue,
      dateOfPurchase,
    };
  }

  sendForm() {
    const {
      name,
      isNameValid,
      mobileNo,
      isMobileInputValid,
      productCategorySelectedValue,
      isProductCodeValid,
      productCode,
      purchaseSelectedValue,
      dateOfPurchase,
    } = this.state;
    const {
      email,
      isEmailInputValid,
      emailInputErrorMsg,
    } = this.emailFields.state;

    if (
      !name ||
      !email ||
      !mobileNo ||
      !productCode ||
      productCategorySelectedValue === "Choose a Product Category" ||
      purchaseSelectedValue === "Choose a Point of Purchase" ||
      !dateOfPurchase
    ) {
      this.showToastrMsg(
        WARRANTY_EXTENSION_COMPONENT.FORM_ERROR_MESSAGES.MANDATORY,
      );
    } else if (name && !isNameValid) {
      this.setState({
        nameErrorMsg:
          WARRANTY_EXTENSION_COMPONENT.FORM_ERROR_MESSAGES.INVALID_NAME,
        nameErrorClass: "",
      });
      this.showToastrMsg(
        WARRANTY_EXTENSION_COMPONENT.FORM_ERROR_MESSAGES.INVALID_NAME,
      );
    } else if (email && !isEmailInputValid) {
      this.showToastrMsg(emailInputErrorMsg);
    } else if (mobileNo && !isMobileInputValid) {
      this.showToastrMsg(
        WARRANTY_EXTENSION_COMPONENT.FORM_ERROR_MESSAGES.INVALID_PHONE,
      );
    } else if (productCode && !isProductCodeValid) {
      this.showToastrMsg(
        WARRANTY_EXTENSION_COMPONENT.FORM_ERROR_MESSAGES.INVALID_PRODUCT_CODE,
      );
    } else {
      // eslint-disable-next-line no-lonely-if
      if (
        isNameValid &&
        isEmailInputValid &&
        isMobileInputValid &&
        isProductCodeValid &&
        dateOfPurchase &&
        productCategorySelectedValue !== "Choose a Product Category" &&
        purchaseSelectedValue !== "Choose a Point of Purchase"
      ) {
        this.setState({ showOtpBlock: true });
      }
    }
  }

  showToastrMsg = (message) => {
    Toastr.showToastr({
      className: "nwc-toastr-list-danger nw-toastr",
      message,
      timeout: 3000,
    });
  }

  closePopUp = () => {
    console.log("Pop Up closed");
    this.setState({ showOtpBlock: false });
  };

  otpVerified() {
    this.setState({ showOtpBlock: false });
    this.props.CommonStore.triggerWarrantyExtension(this.finalFormData).then(
      () => {
        Toastr.showToastr({
          className: "nwc-toastr-list-success nw-toastr",
          message: WARRANTY_EXTENSION_COMPONENT.FORM_ERROR_MESSAGES.SUCCESS,
          timeout: 3000,
        });
        setTimeout(() => {
          window.location.href = "/warranty-extension";
        }, 2000);
      },
      err => {
        console.log("error", err);
        Toastr.showToastr({
          className: "nwc-toastr-list-danger nw-toastr",
          message: WARRANTY_EXTENSION_COMPONENT.FORM_ERROR_MESSAGES.ERROR,
          timeout: 3000,
        });
      },
    );
    console.log("otp verified");
  }

  getProductCategorySelection(selectedValue) {
    this.setState({
      productCategorySelectedValue: selectedValue,
      productCategoryErrorClass: "nwc-hidden",
    });
  }

  getPurchaseSelectSelection(selectedValue) {
    this.setState({
      purchaseSelectedValue: selectedValue,
      pointOfPurchaseErrorClass: "nwc-hidden",
    });
  }

  onBlur() {
    let productCodeErrorClass = "nwc-hidden";
    let isValid = "";
    if (!this.state.isProductCodeValid) {
      productCodeErrorClass = "";
      isValid = "is-invalid";
    }
    this.setState({ productCodeErrorClass, isValid });
  }

  onNameFieldBlur() {
    let nameErrorClass = "nwc-hidden";
    let isValid = "";
    if (!this.state.isNameValid) {
      nameErrorClass = "";
      isValid = "is-invalid";
    }
    this.setState({ nameErrorClass, isValid });
  }

  getValidatedName(e) {
    const validateNameField = this.validateNameFieldRef.getValidatedOutput(
      e.target.value,
    );
    this.setState({
      isNameValid: validateNameField.isValid,
      nameErrorMsg: validateNameField.errorMsg,
      name: validateNameField.value,
      isValid: "",
      nameErrorClass: "nwc-hidden",
    });
  }

  validateProductCode(e) {
    const validateProductCodeField = this.validateProductCodeFieldRef.getValidatedOutput(
      e.target.value,
    );
    this.setState({
      isProductCodeValid: validateProductCodeField.isValid,
      productCodeInputErrorMsg: validateProductCodeField.errorMsg,
      productCode: validateProductCodeField.value,
      isValid: "",
      productCodeErrorClass: "nwc-hidden",
    });
  }

  validateMobileNumber(mobileField) {
    const { value, isValid } = mobileField;
    this.setState({
      mobileNo: value,
      isMobileInputValid: isValid,
    });
  }

  get currentProductCode() {
    const { productCode } = this.state;
    return productCode;
  }

  getDateOfPurchase(date) {
    if (date && date.toLocaleDateString())
      this.setState({
        dateOfPurchase: date.toLocaleDateString(),
        date,
        dateOfPurchaseErrorClass: "nwc-hidden",
      });
  }

  render() {
    const {
      name,
      nameErrorMsg,
      nameErrorClass,
      mobileNo,
      inpList,
      productCategorySelectedValue,
      productCodeInputErrorMsg,
      isValid,
      purchaseSelectedValue,
      purchaseList,
      productCodeErrorClass,
      PRODUCT_CODE_REGEX,
      date,
      nameValidationRegex,
    } = this.state;
    return (
      <GridContainer
        className={`${this.props.containerclassName} wc-warranty-extension-form`}
        onClick={Utils.preventEventPropagation}
      >
        <GridRow className="nw-mobile-only">
          <GridColumn>
            <Banner
              text={WARRANTY_EXTENSION_COMPONENT.FORM_TITLE1}
              className="wc-banner-container"
            />
            <Banner
              text={WARRANTY_EXTENSION_COMPONENT.FORM_TITLE}
              className="wc-banner-container wc-banner-mview-sub-title"
            />
          </GridColumn>
        </GridRow>
        <GridRow className="wc-remarksform-main">
          <GridColumn
            className={`nwc-grid-col-xs-12 wc-remarksform-container ${this.props.formclassName}`}
          >
            <form>
              <Banner
                text={WARRANTY_EXTENSION_COMPONENT.FORM_TITLE1}
                className="wc-banner-container nw-desktop-only wc-we-banner-subtitle"
                textClassName="wc-banner-subtitle"
              />
              <Banner
                text={WARRANTY_EXTENSION_COMPONENT.FORM_TITLE}
                className="wc-banner-container nw-desktop-only wc-banner-desktop-subtitle"
                textClassName="wc-banner-subtitle"
              />
              <RequiredField
                className="nwc-inp  wc-remarksform-input "
                required
              >
                <Input
                  name="name"
                  required="required"
                  type="text"
                  placeholder="Name"
                  value={name}
                  onChange={this.getValidatedName}
                  onBlur={this.onNameFieldBlur}
                  validateWithPattern={nameValidationRegex}
                  minLength="3"
                  ref={values => {
                    this.validateNameFieldRef = values;
                  }}
                />
                <div className={`nw-form-err-msg ${nameErrorClass}`}>
                  {nameErrorMsg}
                </div>
              </RequiredField>
              <EmailInput.component
                className="wc-remarksform-input wc-remarksform-inputmargin"
                name="email"
                type="email"
                placeholder="Email"
                ref={values => {
                  this.emailFields = values;
                }}
                required
              />
              <MobileNumberInput.component
                className="wc-remarksform-input wc-remarksform-inputmargin"
                name="mobile-number"
                placeholder="Mobile Number"
                mobileNo={mobileNo}
                onChange={this.validateMobileNumber}
                ref={values => {
                  this.mobileNoFieldsRef = values;
                }}
                required
              />
              <div className="wc-remarks-checboxcontainer">
                {WARRANTY_EXTENSION_COMPONENT.SAME_MOBILE_NUMBER_TEXT}
              </div>
              <RequiredField
                className="wc-req-field-width wc-we-req-select"
                required
              >
                <Select
                  className="nw-common-select wc-remarksform-input wc-remarksform-inputmargin nwc-inp"
                  selectedValue={productCategorySelectedValue}
                  inpList={inpList}
                  getSelection={this.getProductCategorySelection}
                  renderList={WarrantyForm.getList}
                />
              </RequiredField>
              <div className="nw-form-err-msg" />
              <RequiredField className="nwc-inp  wc-remarksform-input" required>
                <Input
                  className={`wc-remarksform-input wc-remarksform-inputmargin ${isValid}`}
                  name="product-code"
                  placeholder="Product Code (13 digit EAN No)"
                  value={this.currentProductCode}
                  onChange={this.validateProductCode}
                  onBlur={this.onBlur}
                  maxLength="13"
                  type="text"
                  validateWithPattern={PRODUCT_CODE_REGEX}
                  ref={values => {
                    this.validateProductCodeFieldRef = values;
                  }}
                />
                <div className={`nw-form-err-msg ${productCodeErrorClass}`}>
                  {productCodeInputErrorMsg}
                </div>
              </RequiredField>
              <RequiredField
                className="wc-req-field-width wc-we-req-select"
                required
              >
                <Select
                  className="nw-common-select wc-remarksform-input wc-remarksform-inputmargin nwc-inp"
                  selectedValue={purchaseSelectedValue}
                  inpList={purchaseList}
                  getSelection={this.getPurchaseSelectSelection}
                  renderList={WarrantyForm.getList}
                />
              </RequiredField>
              <div className="nw-form-err-msg" />
              <div className="wc-date-wrapper">
                <DateComponent
                  placeholderText="DD/MM/YYYY"
                  getDate={this.getDateOfPurchase}
                  className="wc-date-picker"
                  labelText="Date of Purchase"
                  containerClassName="wc-date-container"
                  dateFormat="dd/MM/yyyy"
                  selected={date}
                  maxDate={new Date()}
                />
              </div>

              <Button
                className="nwc-btn-primary wc-remarksform-btn"
                onClick={this.sendForm}
              >
                {WARRANTY_EXTENSION_COMPONENT.FORM_BUTTON_TEXT}
              </Button>
            </form>
          </GridColumn>
        </GridRow>
        <Modal
          isOpen={this.state.showOtpBlock}
          onClose={this.closePopUp}
          className="wc-circle-otppopup"
        >
          {mobileNo && (
            <WarrantyExtensionOtp
              mobileNumber={mobileNo}
              otpVerified={this.otpVerified}
            />
          )}
        </Modal>
      </GridContainer>
    );
  }
}

WarrantyForm.wrappedComponent.propTypes = {
  containerclassName: PropTypes.string.isRequired,
  formclassName: PropTypes.string.isRequired,
  CommonStore: PropTypes.shape({
    triggerWarrantyExtension: PropTypes.func.isRequired,
  }).isRequired,
};

export default WarrantyForm;
